/* eslint-disable @ms/forbid-file-names */
import { basenameForWebApp } from '.';

export type GetBaseUrl = () => string;

export const getBaseUrl: GetBaseUrl = () => {
  const protocol = window.location.protocol;
  const baseUrl = `${window.location.host}${basenameForWebApp}`;

  return `${protocol}//${baseUrl}`;
};
